<template>
  <div class="mb-3 rounded-md bg-greyLight p-4 text-grey">
    <div class="flex items-center">
      <div class="flex h-12 w-12 items-center justify-center rounded-lg bg-red/10">
        <i class="fas fa-file-pdf text-2xl text-red" />
      </div>
      <div class="ml-3 min-w-0 flex-1">
        <div class="flex items-center space-x-2">
          <div class="truncate text-sm font-semibold">{{ document.name }}</div>
          <div
            v-if="document.isNew"
            class="shrink-0 rounded bg-primary px-2 py-0.5 text-[10px] font-semibold text-grey"
          >
            новый
          </div>
        </div>
        <div class="mt-1 text-xs text-grey text-opacity-50">{{ document.size }}</div>
      </div>
    </div>

    <div class="mt-4 grid grid-cols-4 gap-2">
      <button
        type="button"
        class="flex flex-col items-center justify-center rounded-lg bg-background py-2.5 text-blue transition"
        @click="$emit('open', document)"
      >
        <i class="fas fa-eye text-lg" />
        <span class="mt-1 text-[10px]">Открыть</span>
      </button>

      <button
        type="button"
        class="flex flex-col items-center justify-center rounded-lg bg-background py-2.5 text-blue transition"
        @click="$emit('download', document)"
      >
        <i class="fas fa-download text-lg" />
        <span class="mt-1 text-[10px]">Скачать</span>
      </button>

      <button
        type="button"
        class="flex flex-col items-center justify-center rounded-lg py-2.5 transition"
        :class="
          document.isSigned
            ? 'bg-green/10 text-green'
            : 'bg-blue text-white active:scale-95'
        "
        :disabled="document.isSigned"
        @click="$emit('sign', document)"
      >
        <i :class="document.isSigned ? 'fas fa-check text-lg' : 'fas fa-pen text-lg'" />
        <span class="mt-1 text-[10px]">{{ document.isSigned ? "Подписано" : "Подписать" }}</span>
      </button>

      <button
        type="button"
        class="flex flex-col items-center justify-center rounded-lg py-2.5 transition"
        :class="
          document.isSigned
            ? 'bg-green text-white active:scale-95'
            : 'bg-background text-grey text-opacity-30'
        "
        :disabled="!document.isSigned"
        @click="$emit('send', document)"
      >
        <i class="fas fa-paper-plane text-lg" />
        <span class="mt-1 text-[10px]">Отправить</span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { IDocument } from "@/struct/IDocument/IDocument";
import { Options, Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Options({})
export default class DocumentItem extends Vue {
  @Prop() document!: IDocument;
}
</script>
